// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"577c27de","977":"f7001a46"}[chunkId] + ".chunk.js";
};